// ThingsDuck.js
import Duck from "extensible-duck";
import * as _ from "lodash";
import _async from "async";
import axios from "axios";

import {
  thingsEndPoints,
  groupEndPoints,
  userEndpoints,
  reportsEndPoints,
} from "../api/endpoints";
import HashMap from "hashmap";

let map = new HashMap();



export default new Duck({
  namespace: "AuxoThings",
  store: "things",
  types: ['UPDATE_CENTER','THING_IS_LOADING','GROUP_THINGS_FETCHED','SET_SELECTED_THING'],
  initialState: {
    center: {
      lat: 30.1575,
      lng: 71.5249,
    },
    selectedThing:{},
    groupVehicles: [],
    
  },
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.UPDATE_CENTER:
        return {
          ...state,
          center: { ...action.center },
        };
      case duck.types.GROUP_THINGS_FETCHED:
        return {
          ...state,
          groupVehicles: action.groupVehicles,
        };
      case duck.types.SET_SELECTED_THING:
        return {
          ...state,
          selectedThing: action.selectedThing,
        };
      default:
        return state;
    }
  },
  selectors: {
    root: (state) => state,
  },
  creators: (duck) => ({
    getGroupVehicles: (state) => async (dispatch) => {
      try {
        dispatch({ type: duck.types.THING_IS_LOADING, isLoading: true });

        const response = await axios.get(thingsEndPoints.getGroupDevices(state.groupId));
        const groupVehicles = response.data;
        dispatch({ type: duck.types.THING_IS_LOADING, isLoading: false });
        dispatch({ type: duck.types.GROUP_THINGS_FETCHED, groupVehicles });
      } catch (e) {
        dispatch({ type: duck.types.THING_IS_LOADING, isLoading: false });
        throw e;
      }
    },
    getDatabasedonSingleImei : (state) => async (dispatch) => {
      const response = await axios.get(thingsEndPoints.getSingleDataonImei(state.imei,state.interval));
      return response.data;

    },
    getObservations: (thingName, data) => async (dispatch, getState) => {

      const response = await axios.get(thingsEndPoints.observations(thingName, data));
      return response.data;
    },
    getObservationsTemp: (thingName, data) => async (dispatch, getState) => {

      const response = await axios.get(thingsEndPoints.observationsTemp(thingName, data));
      return response.data;
    },
    getDashboardData : () => async (dispatch, getState) => {
      let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
      const response = await axios.get(thingsEndPoints.dashboardData(companyInfo.groupId));
  
      return response.data;
    },
    updateThingData : (state) => async (dispatch, getState) => {

      const response = await axios.put(thingsEndPoints.updateThing(state.imei),state.data);
      return true;
    },
    updateThingsData : (state) => async (dispatch, getState) => {

      const imeis = state.imeis;
      const data = state.data;

      const response = await axios.post(thingsEndPoints.updateThings(), { imeis, data});
      return true;
    },
    
    ChangeCenter: (center) => async (dispatch) => {
      dispatch({ type: duck.types.UPDATE_CENTER, center });
    },
    selectedThingData: (thing) => async (dispatch) => {
      dispatch({ type: duck.types.SET_SELECTED_THING, 'selectedThing':thing });
    },
  }),
});
